import { $authHost } from ".."

export const checkPackAPI = async ({ keyCrmOrderNumber }) => {
    const {data} = await $authHost.post('api/pack/check', {keyCrmOrderNumber})
    return data
}

export const createPackAPI = async ({ keyCrmOrderNumber }) => {
    const {data} = await $authHost.post('api/pack/create', {keyCrmOrderNumber})
    return data
}

export const getPacksAPI = async ({ offset, limit, query }) => {

    let params = ''
    if (query) {
        params = `?query=${query}`
    } else if ((offset || offset === 0) && limit) {
        params = `?offset=${offset}&limit=${limit}`
    }

    const {data} = await $authHost.get(`api/pack/${params}`)
    return data
}

export const getPackQrCodesAPI = async ({ id, type }) => {
    let params = ''

    if (type) {
        params = `?type=${type}`
    }

    const {data} = await $authHost.get(`api/pack/qr_codes/${id}${params}`)
    return data
}

export const getPackBoxesOnlyQrCodesAPI = async ({ id, type }) => {
    let params = ''

    if (type) {
        params = `?type=${type}`
    }

    const {data} = await $authHost.get(`api/pack/qr_codes/${id}/boxes_only${params}`)
    return data
}

export const getPackPaletsOnlyQrCodesAPI = async ({ id }) => {
    const {data} = await $authHost.get(`api/pack/qr_codes/${id}/palets_only`)
    return data
}